import styles from './RoomPlan.module.css';

/**
 * A single-bed ward room seen from above, drawn to sit under the position markers (580 × 380):
 * the bed's head against the top wall, a window on the right, the door at the bottom.
 */
export function RoomPlan({ className }: { readonly className?: string | undefined }) {
  return (
    <svg
      className={className}
      viewBox="0 0 580 380"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden
      focusable="false"
    >
      <defs>
        <pattern id="room-plan-tiles" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M40 0H0V40" className={styles.tileLine} />
        </pattern>
      </defs>

      <rect width="580" height="380" className={styles.floor} />
      <rect width="580" height="380" fill="url(#room-plan-tiles)" />

      {/* Window (right wall) and door (bottom wall, opening inwards). */}
      <rect x="566" y="110" width="14" height="160" className={styles.window} />
      <path d="M228 294A72 72 0 0 1 300 366" className={styles.doorSwing} />
      <line x1="228" y1="366" x2="228" y2="294" className={styles.door} />

      {/* Walls, with the door's gap. */}
      <path d="M7 7H573V110M573 270V373H300M228 373H7V7" className={styles.wall} />

      {/* Bedside cabinet and the bed. */}
      <rect x="180" y="22" width="46" height="40" rx="4" className={styles.furniture} />
      <rect x="240" y="16" width="100" height="214" rx="10" className={styles.bed} />
      <rect x="254" y="26" width="72" height="34" rx="8" className={styles.pillow} />
      <rect x="244" y="96" width="92" height="128" rx="8" className={styles.blanket} />
      <line x1="244" y1="112" x2="336" y2="112" className={styles.fold} />

      {/* Visitor chair by the window. */}
      <rect x="470" y="196" width="44" height="44" rx="8" className={styles.furniture} />
    </svg>
  );
}
